import React, {createContext, useReducer, useContext, useRef} from 'react'
import PropTypes from 'prop-types'

const initialState = {
    compareItems: [],
}

const compareActionTypes = {
    ADD_ITEM: 'ADD_ITEM',
    ADD_ITEMS: 'ADD_ITEMS',
    REMOVE_ITEM: 'REMOVE_ITEM',
    UPDATE_ITEM: 'UPDATE_ITEM',
    CLEAR_ITEMS: 'CLEAR_ITEMS',
}

const compareReducer = (state, action) => {
    switch (action.type) {
        case compareActionTypes.ADD_ITEM:
            return {
                ...state,
                compareItems: [...state.compareItems, action.payload],
            }
        case compareActionTypes.ADD_ITEMS:
            return {
                ...state,
                compareItems: [...state.compareItems, ...action.payload],
            }
        case compareActionTypes.REMOVE_ITEM:
            return {
                ...state,
                compareItems: state.compareItems.filter(
                    (item) => item.productId !== action.payload.productId,
                ),
            }
        case compareActionTypes.UPDATE_ITEM: {
            const nextItems = [...state.compareItems]
            nextItems[action.payload.index] = action.payload.item
            return {
                ...state,
                compareItems: nextItems,
            }
        }
        case compareActionTypes.CLEAR_ITEMS:
            return {
                ...state,
                compareItems: [],
            }
        default:
            return state
    }
}

export const CompareContext = createContext()

export const CompareProvider = ({children}) => {
    const [state, dispatch] = useReducer(compareReducer, initialState)
    const compareBannerRef = useRef(null)

    const addItem = (item) => {
        dispatch({type: 'ADD_ITEM', payload: item})
    }

    const addItems = (items) => {
        dispatch({type: 'ADD_ITEMS', payload: items})
    }

    const removeItem = (item) => {
        dispatch({type: 'REMOVE_ITEM', payload: item})
    }

    const updateItem = (index, item) => {
        dispatch({type: 'UPDATE_ITEM', payload: {index, item}})
    }

    const clearItems = () => {
        dispatch({type: 'CLEAR_ITEMS'})
    }

    return (
        <CompareContext.Provider
            value={{state, addItem, addItems, removeItem, updateItem, clearItems, compareBannerRef}}
        >
            {children}
        </CompareContext.Provider>
    )
}

CompareProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useCompare = () => {
    return useContext(CompareContext)
}
